import React from 'react'
import styled from 'styled-components'
import InfoIcon from 'images/info.svg'

const FormErrorMessage = styled.div`
  font-weight: 400;
  font-size: 11px;
  margin-top: 5px;
  color: #ff3d71;
  padding-left: 24px;
  position: relative;
  line-height: 20px;

  & + div > input,
  & + div > textarea {
    border: 1px solid #ff3d71;
  }
`

const IconStyled = styled(InfoIcon)`
  display: block;
  position: absolute;
  left: 0;
  top: 0;
`

const ErrorMessage = ({ children, ...props }) => (
  <FormErrorMessage {...props}>
    <IconStyled /> <span>{children}</span>
  </FormErrorMessage>
)

export default ErrorMessage
